import { render, staticRenderFns } from "./NewComplieCreatedSheetFileScroll.vue?vue&type=template&id=4efc887e&scoped=true"
import script from "./NewComplieCreatedSheetFileScroll.vue?vue&type=script&lang=js"
export * from "./NewComplieCreatedSheetFileScroll.vue?vue&type=script&lang=js"
import style0 from "./NewComplieCreatedSheetFileScroll.vue?vue&type=style&index=0&id=4efc887e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc887e",
  null
  
)

export default component.exports